import { isDefined, isNonEmpty } from '@sgme/fp';

import { useForwardAccumulatorSelector } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { ErrorRates } from '@/App/tiles/shared/ErrorRates.tsx';
import { getForwardAccumulatorQuote, getForwardAccumulatorRfsId } from '@/store/forwardAccumulator/selectors.ts';

export function StreamingError() {
  const { errorCode, errorMessage, multipassErrorCode, rfsId, predealChecks } = useForwardAccumulatorSelector(
    (accumulator) => {
      const rfsId = getForwardAccumulatorRfsId(accumulator);
      if (accumulator.properties.rfs.status !== 'ERROR') {
        return {
          errorCode: undefined,
          errorMessage: undefined,
          multipassErrorCode: undefined,
          rfsId: rfsId,
          predealChecks: [],
        };
      }

      return {
        errorCode: accumulator.properties.rfs.error.errorCode,
        errorMessage: accumulator.properties.rfs.error.errorMessage,
        multipassErrorCode: accumulator.properties.rfs.error.multipassErrorCode,
        rfsId,
        predealChecks: getForwardAccumulatorQuote(accumulator)?.predealChecks ?? [],
      };
    },
  );

  function computeErrorTranslationKey(errorCode: string, errorMessage: string): string {
    const newErrorCode = errorMessage.substring(0, errorMessage.indexOf('|'));
    if (isNonEmpty(newErrorCode)) {
      return `${newErrorCode}_${errorCode}`;
    }
    return errorCode;
  }

  const errorKey =
    isDefined(errorMessage) && isDefined(errorCode) ? computeErrorTranslationKey(errorCode, errorMessage) : errorCode;

  const multipass = isDefined(errorCode) ? { code: multipassErrorCode, sessionId: rfsId, predealChecks } : undefined;

  return <ErrorRates code={errorKey} message={errorMessage} multipass={multipass} />;
}
